const searchIndexRequests = new Map();

function getSearchIndex(url) {
  if (!searchIndexRequests.has(url)) {
    const request = fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to load search index: ${response.status}`);
        }

        return response.json();
      })
      .then((entries) => {
        if (!Array.isArray(entries)) {
          throw new Error('Search index must contain an array of entries.');
        }

        return entries;
      });

    searchIndexRequests.set(url, request);
  }

  return searchIndexRequests.get(url);
}

class RandomPost extends HTMLElement {
  connectedCallback() {
    if (this.link) {
      return;
    }

    this.link = document.createElement('a');
    this.link.className = 'random-post-link';
    if (this.classList.contains('home-masonry-teasers__random')) {
      this.link.classList.add('home-masonry-teaser');
    }
    this.link.setAttribute('aria-disabled', 'true');

    while (this.firstChild) {
      this.link.append(this.firstChild);
    }

    this.append(this.link);
    this.initialize();
  }

  async initialize() {
    try {
      const { type, category, url } = this.dataset;
      if (!['post', 'joke'].includes(type)) {
        throw new Error('Random post requires data-type="post" or data-type="joke".');
      }
      if (!url) {
        throw new Error('Random post requires a data-url attribute.');
      }

      const entries = await getSearchIndex(new URL(url, document.baseURI).href);
      const matches = entries.filter((entry) => {
        if (!entry || entry.type !== type || typeof entry.url !== 'string') {
          return false;
        }
        if (category && !Array.isArray(entry.categories)) {
          return false;
        }
        if (category && !entry.categories.includes(category)) {
          return false;
        }

        try {
          const entryUrl = new URL(entry.url, window.location.origin);
          if (entryUrl.origin !== window.location.origin) {
            return false;
          }

          return type === 'joke'
            ? /^\/witz\/[^/]+\.html$/.test(entryUrl.pathname)
            : /^\/(?:blog|stories)\/[^/]+\.html$/.test(entryUrl.pathname);
        } catch {
          return false;
        }
      });

      if (matches.length === 0) {
        throw new Error(`Search index contains no ${type} entries matching the requested category.`);
      }

      const entry = matches[Math.floor(Math.random() * matches.length)];
      this.link.href = new URL(entry.url, window.location.origin).href;
      this.link.removeAttribute('aria-disabled');
    } catch (error) {
      console.error('Could not initialize a random post link.', error);
    }
  }
}

customElements.define('random-post', RandomPost);
